import { useTranslation } from "react-i18next";

type SearchDialogFooterProps = {
  isMac: boolean;
};

export function SearchDialogFooter({ isMac }: SearchDialogFooterProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row items-center justify-start gap-6 text-xs text-muted-foreground">
      <div className="flex items-center gap-1.5">
        <kbd className="inline-flex h-5 min-w-5 items-center justify-center rounded border  bg-muted px-1.5 font-mono text-[10px] font-medium">
          Enter
        </kbd>
        <span>{t("search.shortcuts.select")}</span>
      </div>
      <div className="flex items-center gap-1.5">
        <kbd className="inline-flex h-5 min-w-5 items-center justify-center rounded border  bg-muted px-1.5 font-mono text-[10px] font-medium">
          Esc
        </kbd>
        <span>{t("search.shortcuts.close")}</span>
      </div>
      <div className="flex items-center gap-1.5">
        <kbd className="inline-flex h-5 min-w-5 items-center justify-center rounded border  bg-muted px-1.5 font-mono text-[10px] font-medium">
          {isMac ? "⌘" : "Ctrl"}K
        </kbd>
        <span>{t("search.shortcuts.search")}</span>
      </div>
    </div>
  );
}
